import Vue from 'vue';
import Vuetify from 'vuetify';
import pl from 'vuetify/src/locale/pl';
import 'vuetify/dist/vuetify.min.css';
import {library, IconPack} from '@fortawesome/fontawesome-svg-core'; // Core SVG
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome'; // Integration
import {
    faCaretDown,
    faChevronDown,
    faSortUp,
    faChevronLeft,
    faChevronRight,
    faPlus,
    faMinus,
    faClock,
    faCalendar,
    faCog,
    faCheckSquare
} from '@fortawesome/free-solid-svg-icons';
import {faSquare} from '@fortawesome/free-regular-svg-icons';
import {coreIcons} from 'core-icons';
import {CoreLoginPanelProvider} from 'core-login-panel';

library.add(
    faCaretDown as unknown as IconPack,
    faChevronDown as unknown as IconPack,
    faSortUp as unknown as IconPack,
    faChevronLeft as unknown as IconPack,
    faChevronRight as unknown as IconPack,
    faPlus as unknown as IconPack,
    faMinus as unknown as IconPack,
    faClock as unknown as IconPack,
    faCalendar as unknown as IconPack,
    faCog as unknown as IconPack,
    faCheckSquare as unknown as IconPack,
    faSquare as unknown as IconPack
);

const customIcons = {
    clock: {
        component: FontAwesomeIcon,
        props: {
            icon: ['fas', 'clock']
        }
    },
    calendar: {
        component: FontAwesomeIcon,
        props: {
            icon: ['fas', 'calendar']
        }
    },
    cog: {
        component: FontAwesomeIcon,
        props: {
            icon: ['fas', 'cog']
        }
    }
};

Vue.use(Vuetify);

Object.assign(customIcons, coreIcons);
CoreLoginPanelProvider.mergeIcons(customIcons);

export default new Vuetify({
    lang: {
        locales: {pl},
        current: 'pl'
    },
    icons: {
        iconfont: 'faSvg',
        values: customIcons
    }
});
